/**
 * Enroute JS Core Utilities
 * Centralized helper methods mounted under window._erj_
 *
 * This file consolidates commonly used functions so they can be shared
 * across sections/snippets without redefining globals inline.
 */
(function () {
  // Ensure namespace
  window._erj_ = window._erj_ || {};

  if (!window._erj_.isWeekend) {
    window._erj_.isWeekend = function (date) {
      const dayIndex = date.getDay();
      return dayIndex === 0 || dayIndex === 6;
    };
  }

  /**
   * deprecated - calculate the delivery date based on the business days
   * @param {Date} startDate
   * @param {number} businessDaysToAdd
   * @param {string} countryCode
   * @returns {Promise<Date>} - final date
   */
  // if (!window._erj_.calculateDeliveryDate){
  //   window._erj_.calculateDeliveryDate = async function (startDate, businessDaysToAdd, countryCode) {
  //     // step1: get public holidays
  //     if (!window._erj_?.publicHolidays){
  //       try {
  //         const year = startDate.getFullYear();
  //         const response = await fetch(`https://date.nager.at/api/v3/PublicHolidays/${year}/${countryCode}`);
  //         if (response.ok) {
  //           const publicHolidays = await response.json();
  //           window._erj_ = window._erj_ || {};
  //           window._erj_.publicHolidays = new Set(publicHolidays.map(h => h.date));
  //         }
  //       } catch (error) {
  //         console.error("get public holidays error:", error);
  //       }
  //     }

  //     // Step 2: Loop to calculate working days
  //     let currentDate = new Date(startDate);
  //     let daysAdded = 0;

  //     while (daysAdded < businessDaysToAdd) {
  //       currentDate = new Date(currentDate);
  //       currentDate.setDate(currentDate.getDate() + 1);
  //       const formattedDate = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')}`;

  //       const isWeekendDay = window._erj_.isWeekend(currentDate);
  //       const isHoliday = window._erj_.publicHolidays.has(formattedDate);

  //       if (!isWeekendDay && !isHoliday) {
  //         daysAdded++;
  //       }
  //     }
  //     return currentDate;
  //   }
  // }
  /**
   * Parse product info JSON from a container.
   *
   * - Looks for a <script type="application/json" class="product-info-json"> inside the provided container.
   * - Falls back to a generic element with class .product-info-json if needed.
   * - Returns parsed object or null on failure.
   *
   * @param {Element|Document} [container=document] DOM node within which to search
   * @returns {object|null}
   */
  if (!window._erj_.getProductInfo) {
    window._erj_.getProductInfo = function (container) {
      const scope = container || document;
      const jsonEl =
        scope.querySelector(
          'script.product-info-json[type="application/json"]'
        ) || scope.querySelector(".product-info-json");
      if (!jsonEl) return null;
      const text = (jsonEl.textContent || "").trim();
      if (!text) return null;
      try {
        return JSON.parse(text);
      } catch (err) {
        console.error("[getProductInfo] JSON parse failed:", err);
        return null;
      }
    };
  }

  /**
   * Get global locale strings.
   *
   * - Reads JSON from <script id="global-locale-data" type="application/json">.
   * - Returns {} on failure.
   *
   * @returns {object}
   */
  if (!window._erj_.getGlobalLocaleStrings) {
    window._erj_.getGlobalLocaleStrings = function () {
      try {
        const el = document.getElementById("global-locale-data");
        const text = (el?.textContent || "").trim();
        return text ? JSON.parse(text) : {};
      } catch (e) {
        console.error("[getGlobalLocaleStrings] JSON parse failed:", e);
        return {};
      }
    };
  }

  if (!window._erj_.isMobileViewport){
    window._erj_.isMobileViewport = function() {
      try {
        const mq767 = window.matchMedia("(max-width: 767px)");
        const mq1024Portrait = window.matchMedia("(max-width: 1024px) and (orientation: portrait)");
        return mq767.matches || mq1024Portrait.matches;
      } catch (e) {
        const portrait = typeof window.orientation === "number"
          ? window.orientation === 0 || window.orientation === 180
          : window.innerHeight >= window.innerWidth;
        return window.innerWidth <= 767 || (window.innerWidth <= 1024 && portrait);
      }
    }
  }
})();
